import { ref, readonly } from "vue";
const isFullscreen = ref(checkIfIsFullscreen());
window.addEventListener("resize", () => {
  isFullscreen.value = checkIfIsFullscreen();
});
function checkIfIsFullscreen() {
  return window.outerHeight === window.screen.height;
}
function useIsFullscreen() {
  return readonly(isFullscreen);
}
export {
  useIsFullscreen
};
//# sourceMappingURL=index.mjs.map
